// extracted by mini-css-extract-plugin
module.exports = {"container":"BaseHeader_container_35PSQ","title":"BaseHeader_title_JqKGR","language":"BaseHeader_language_2_r8r"};